module.exports = __webpack_public_path__ + "static/media/arrow-circle-left.ff59171d.svg";